import { DateUtils } from '@vectord/utils';

export default function getEndTimeOfInterviewbitTest(
  interviewbitTest,
  duration
) {
  const startTime = new Date(interviewbitTest.start_time).getTime();
  const updatedInterval = Math.max(duration, interviewbitTest.window);

  return new Date(startTime + updatedInterval * DateUtils.ONE_MINUTE);
}
